import React, { useEffect, useState } from 'react';
import '@/pages/intelligence/assets/scss/MobileDevice/index.scss';
import Newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
import './index.scss';
import { useIntl } from 'umi';
import Looker from '@/pages/home/pages/report/Looker';
import { Layout, notification, Button } from 'tea-component';
// import Newzoo from '@/pages/intelligence/assets/svg/dataSource/newzoo.svg';
import Loading from '@/pages/intelligence/components/Loading';
import { DownloadMobileDeviceDataExcel } from '@/pages/intelligence/services/mobileDevice';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';

const { Content } = Layout;

const statsUrl = 'https://databrain.cloud.looker.com/embed/dashboards/107';
const models = ["intelligence"];

const PRESET_ID = '7b1be4a4-19f1-45f8-adb0-5d5eaa37a667';
// 文件名来源于cos上存储的文件名，假设文件名错误，将出现下载失败
const FILE_NAME = 'Device Export-202310.xlsx';

export default function MobileDeviceStats() {
  // 用于控制下载按钮不能重复点击
  const [exportLoading, setExportLoading] = useState(false);
  const { formatMessage } = useIntl();


  // 通知弹框
  const notice = (type: 'success'|'error') => {
    const SUCCESS_MSG = 'Download Successfully.';
    const FAIL_MSG = 'Download Failed, please try again.'
    notification[type]({
      unique: true,
      description: type === 'success' ? SUCCESS_MSG : FAIL_MSG,
    });
  }

  // 下载主体，用a标签模拟点击
  const download = (blobData: Blob, cb: Function) => {
    try {
        const link = document.createElement('a');
        const blob = new Blob([blobData], { type: 'application/vnd.ms-excel;charset=utf-8' });
        link.href = window.URL.createObjectURL(blob);
        link.download = FILE_NAME;
        let event = null;
        if (window.MouseEvent) {
          event = new MouseEvent('click');
        } else {
          event = document.createEvent('MouseEvents');
        }
        const flag = link.dispatchEvent(event);
        window.URL.revokeObjectURL(link.href);
        cb(flag);
    } catch (err) {
        console.error(err)
        cb(false);
        throw err;
    }
  }


  const downloadMobileModels = async () => {
    if(exportLoading) return
    setExportLoading(true);
    // const monthStr = getMonthStr(month);
    // 2024-05-15热更暂时写死参数
    let params = {
      start_date: `2023-10-01`,
      end_date: `2023-10-01`,
    }
    DownloadMobileDeviceDataExcel(params).then((res) => {
      if (res) download(res, (flag: boolean) => {
        setExportLoading(false);
        if (flag) return notice('success');
        notice('error');
      });
    }).catch(() => {
      setExportLoading(false);
      notice('error');
    });
  }

  
  return (
    <Content className="dbi-mobilestats">
      <Content.Header
        className="dbi-header"
        title={
          <div className="dbi-mobileoverview-title">
            {formatMessage({ id: 'dbi-mobile-device-stats-title' })}
            {/* <img src={Newzoo} className="view-title-img" /> */}
          </div>
        }
        operation={
          <Button 
          type="text"
          className="ns-btn--border manage-btn" 
          style={{width: '378px'}}
          loading={exportLoading} 
          onClick={downloadMobileModels}>
            {
              exportLoading ?
                <Loading /> :
                formatMessage({ id: 'dbi-mobile-device-download_info_btn' })
            }
          </Button>
        }
      ></Content.Header>
      <Content.Body full className='dbi-mobiledevice-stat'>
        <MarqueeBanner />
        <Looker 
          url={statsUrl}
          models={models} 
        />
      </Content.Body>
    </Content>
  );
}
